import React, { useState, useEffect, useMemo, Component } from 'react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-quartz.css';
import { AgGridReact } from 'ag-grid-react';
import '../pagination/pagination.css';
import '../../Assets/Style/style.css';
import Pagination from '../pagination/pagination';
import LeaseApiService from '../../services/apiService';
import { RiRefreshLine } from 'react-icons/ri';
import { FaFileCircleExclamation } from 'react-icons/fa6';
import { FaRegEye, FaTrash, FaFileExport } from 'react-icons/fa';
import { HiPencil } from 'react-icons/hi2';
import { IoAddSharp } from 'react-icons/io5';
import Select from 'react-select';
import Modal from 'react-bootstrap/Modal';
import { useTranslation } from 'react-i18next';
import i18n from '../../../i18n';
import jsPDF from "jspdf";
import "jspdf-autotable";
import { useSelector } from 'react-redux';
import { getRole } from '../../../Redux/selecters';
import CreateUnitMaster from './createUnit';
import UpdateUnitMaster from './updateUnitMaster';
import ColumnFilterHeader from './columnFilterHeader';

const SEARCH_DROPDOWN_TYPES =
  'UMSearchPropertyNo,UMSearchCommunityName,UMSearchStatus,UMSearchUnitType,UMSearchBedrooms,UMSearchUnitView,UMSearchLeased,UMSearchBathrooms,UMSearchBalcony,UMSearchStoreRooms,UMSearchFurnishing,UMSearchMaidRoom';

const selectTheme = (theme) => ({
  ...theme,
  borderRadius: 5,
  padding: 9,
});

const selectStyles = {
  menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
    color: state.isFocused ? '#000 ' : '#000',
    ':hover': {
      backgroundColor: '#F5F5F5',
      color: '#000 ',
    },
  }),
};

const getSelectValue = (option) => {
  if (!option) return '';
  return option?.value?.value ?? option?.label ?? '';
};

const appendParamIfFilled = (params, key, value) => {
  if (value !== null && value !== undefined && String(value).trim() !== '') {
    params.append(key, value);
  }
};

const SearchSelect = ({ label, value, options, onChange, isDisabled }) => (
  <div className="d-flex align-items-center unit-search-field">
    <label className="form-label pt-2 start mb-0">{label}</label>
    <Select
      className="p-0 w-100"
      theme={selectTheme}
      menuPortalTarget={document.body}
      styles={selectStyles}
      value={value}
      onChange={onChange}
      options={options?.map((item) => ({ value: item, label: item?.text }))}
      isClearable
      isDisabled={isDisabled}
    />
  </div>
);

const SearchVerticalRange = ({ minLabel, maxLabel, minName, maxName, minValue, maxValue, onChange }) => (
  <div className="unit-search-compact-range d-flex flex-column gap-2">
    <div className="d-flex align-items-center gap-1">
      <label className="form-label pt-2 start mb-0 text-nowrap">{minLabel}</label>
      <input type="number" className="p-2 form-control unit-search-range-input" name={minName} value={minValue} onChange={onChange} />
    </div>
    <div className="d-flex align-items-center gap-1">
      <label className="form-label pt-2 start mb-0 text-nowrap">{maxLabel}</label>
      <input type="number" className="p-2 form-control unit-search-range-input" name={maxName} value={maxValue} onChange={onChange} />
    </div>
  </div>
);

const initialFormData = {
  propertyNo: null,
  communityName: null,
  unitNo: null,
  status: null,
  unitType: null,
  bedrooms: null,
  unitView: null,
  leased: null,
  bathrooms: null,
  balcony: null,
  storeRooms: null,
  furnishing: null,
  maidRoom: null,
  psfMin: '',
  psfMax: '',
  budgetMin: '',
  budgetMax: '',
  sizeMin: '',
  sizeMax: '',
};

const UnitListing = () => {
  const { t } = useTranslation();
  const apiService = new LeaseApiService();
  const [loading, setLoading] = useState(true);
  const [rowData, setRowData] = useState([]);
  const [pageSize, setPageSize] = useState(20);
  const [pagination, setPagination] = useState();
  const [FilterTab, setFilterTab] = useState(true);
  const [exportData, setExportData] = useState([]);
  const [searchDropdowns, setSearchDropdowns] = useState({});
  const [unitNoOptions, setUnitNoOptions] = useState([]);
  const [formModal, setFormModal] = useState({ mode: null, data: null });
  const [columnFilters, setColumnFilters] = useState({});
  const [selectedRow, setSelectedRow] = useState(null);
  const [previewModal, setPreviewModal] = useState(false);
  const role = useSelector(getRole);
  const isAdmin = role === 'Admin' || role === 'admin';

  const [formData, setFormData] = useState(initialFormData);

  useEffect(() => {
    const loadSearchDropdowns = async () => {
      try {
        const params = new URLSearchParams();
        params.append('dropdownTypes', SEARCH_DROPDOWN_TYPES);
        const res = await apiService.getApiParamater('GET_UNIT_MULTIDROP', `?${params.toString()}`);
        setSearchDropdowns(res?.data?.dropdowns || {});
      } catch (e) {
        console.error('Error loading search dropdowns:', e);
      }
    };
    loadSearchDropdowns();
    getItems();
  }, []);

  const getItems = async (newPageNo = pagination?.currentPage) => {
    try {
      const params = new URLSearchParams();
      params.append('PageNo', newPageNo || 1);
      params.append('PageSize', pageSize || 20);
      appendParamIfFilled(params, 'PropertyNo', getSelectValue(formData.propertyNo));
      appendParamIfFilled(params, 'CommunityName', getSelectValue(formData.communityName));
      appendParamIfFilled(params, 'UnitNo', getSelectValue(formData.unitNo));
      appendParamIfFilled(params, 'Status', getSelectValue(formData.status));
      appendParamIfFilled(params, 'UnitType', getSelectValue(formData.unitType));
      appendParamIfFilled(params, 'Bedrooms', getSelectValue(formData.bedrooms));
      appendParamIfFilled(params, 'UnitView', getSelectValue(formData.unitView));
      appendParamIfFilled(params, 'Leased', getSelectValue(formData.leased));
      appendParamIfFilled(params, 'Bathrooms', getSelectValue(formData.bathrooms));
      appendParamIfFilled(params, 'Balcony', getSelectValue(formData.balcony));
      appendParamIfFilled(params, 'StoreRooms', getSelectValue(formData.storeRooms));
      appendParamIfFilled(params, 'PsfMin', formData.psfMin);
      appendParamIfFilled(params, 'PsfMax', formData.psfMax);
      appendParamIfFilled(params, 'BudgetMin', formData.budgetMin);
      appendParamIfFilled(params, 'BudgetMax', formData.budgetMax);
      appendParamIfFilled(params, 'SizeMin', formData.sizeMin);
      appendParamIfFilled(params, 'SizeMax', formData.sizeMax);
      appendParamIfFilled(params, 'Furnishing', getSelectValue(formData.furnishing));
      appendParamIfFilled(params, 'MaidRoom', getSelectValue(formData.maidRoom));
      const res = await apiService.getApiParamater('GET_UNIT_LIST', `?${params.toString()}`);
      setLoading(false);
      setRowData(res?.data?.result || []);
      getAllItems(res.data.paginationData)
      setPagination(res.data.paginationData);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };

  const getAllItems = async (page) => {
    try {
      const params = new URLSearchParams();
      params.append('PageNo', 1);
      params.append('PageSize', page?.totalRecords || 20);
      appendParamIfFilled(params, 'PropertyNo', getSelectValue(formData.propertyNo));
      appendParamIfFilled(params, 'CommunityName', getSelectValue(formData.communityName));
      appendParamIfFilled(params, 'UnitNo', getSelectValue(formData.unitNo));
      appendParamIfFilled(params, 'Status', getSelectValue(formData.status));
      appendParamIfFilled(params, 'UnitType', getSelectValue(formData.unitType));
      appendParamIfFilled(params, 'Bedrooms', getSelectValue(formData.bedrooms));
      appendParamIfFilled(params, 'UnitView', getSelectValue(formData.unitView));
      appendParamIfFilled(params, 'Leased', getSelectValue(formData.leased));
      appendParamIfFilled(params, 'Bathrooms', getSelectValue(formData.bathrooms));
      appendParamIfFilled(params, 'Balcony', getSelectValue(formData.balcony));
      appendParamIfFilled(params, 'StoreRooms', getSelectValue(formData.storeRooms));
      appendParamIfFilled(params, 'PsfMin', formData.psfMin);
      appendParamIfFilled(params, 'PsfMax', formData.psfMax);
      appendParamIfFilled(params, 'BudgetMin', formData.budgetMin);
      appendParamIfFilled(params, 'BudgetMax', formData.budgetMax);
      appendParamIfFilled(params, 'SizeMin', formData.sizeMin);
      appendParamIfFilled(params, 'SizeMax', formData.sizeMax);
      appendParamIfFilled(params, 'Furnishing', getSelectValue(formData.furnishing));
      appendParamIfFilled(params, 'MaidRoom', getSelectValue(formData.maidRoom));
      const res = await apiService.getApiParamater('GET_UNIT_LIST', `?${params.toString()}`);
      setLoading(false);
      setExportData(res?.data?.result || []);
    } catch (error) {
      console.error('Error fetching data:', error);
      setLoading(false);
    }
  };
  const emptyValueFormatter = (params) => {
    const v = params.value;
    if (v === null || v === undefined || v === '' || v === '0') return '--';
    return v;
  };
  const accessors = {
    facilities: (row) => row?.facilities ?? row?.Facilities ?? row?.furnishing ?? row?.Furnishing ?? row?.furnished ?? row?.Furnished ?? '',
    community: (row) => row?.community_Name ?? row?.Community_Name ?? row?.communityName ?? row?.community ?? '',
    maidRoom: (row) => row?.storeRooms ?? row?.store_Rooms ?? row?.StoreRooms ?? row?.maid_Room ?? '',
    unitPrice: (row) => row?.total_Value ?? row?.totalValue ?? row?.unit_Price ?? row?.unitPrice ?? row?.Unit_Price ?? row?.UnitPrice ?? '',
  };
  const displayValue = (row, field, accessor) => emptyValueFormatter({ value: accessor ? accessor(row) : row?.[field] });
  const buildFilterParams = (field, accessor) => ({
    getValues: () => rowData.map((r) => displayValue(r, field, accessor)),
    selected: columnFilters[field],
    onChange: (vals) => setColumnFilters((prev) => ({ ...prev, [field]: vals })),
    onClear: () =>
      setColumnFilters((prev) => {
        const next = { ...prev };
        delete next[field];
        return next;
      }),
  });
  const filteredRowData = useMemo(() => {
    const activeFields = Object.keys(columnFilters).filter((f) => columnFilters[f] && columnFilters[f].length);
    if (!activeFields.length) return rowData;
    return rowData.filter((row) => activeFields.every((field) => columnFilters[field].includes(displayValue(row, field, accessors[field]))));
  }, [rowData, columnFilters]);

  const columnDefs = [
    {
      headerName: t('common.actions'),
      field: 'scheduleId',
      cellRenderer: BtnCellRenderer,
      pinned: 'left',
      cellRendererParams: {
        onView: (rowsData) => handleView(rowsData),
        onEdit: (rowsData) => handleEdit(rowsData),
        onDelete: (rowsData) => handleDelete(rowsData),
        canDelete: isAdmin,
      },
      suppressMovable: true,
      sortable: false,
      filter: false,
      width: 110,
    },
    {
      headerName: t('unitMaster.columns.refNo'),
      field: 'ref_No',
      suppressMovable: true,
      sortable: true,
      width: 150,
      pinned: 'left',
      valueFormatter: emptyValueFormatter,
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('ref_No'),
    },
    {
      headerName: t('unitMaster.columns.propertyName'),
      field: 'property_Name',
      suppressMovable: true,
      sortable: true,
      width: 200,
      valueFormatter: emptyValueFormatter,
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('property_Name'),
    },
    {
      headerName: t('unitMaster.columns.unitNo'),
      field: 'unit_No',
      suppressMovable: true,
      sortable: true,
      width: 120,
      valueFormatter: emptyValueFormatter,
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('unit_No'),
    },
    {
      headerName: t('unitMaster.columns.unitType'),
      field: 'unit_Type',
      suppressMovable: true,
      sortable: true,
      width: 120,
      valueFormatter: emptyValueFormatter,
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('unit_Type'),
    },
    {
      headerName: t('unitMaster.columns.unitCategory'),
      field: 'unit_Category',
      suppressMovable: true,
      sortable: true,
      width: 120,
      valueFormatter: emptyValueFormatter,
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('unit_Category'),
    },
    {
      headerName: t('unitMaster.columns.unitClass'),
      field: 'unit_Class',
      suppressMovable: true,
      sortable: true,
      width: 120,
      valueFormatter: emptyValueFormatter,
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('unit_Class'),
    },
    {
      headerName: t('unitMaster.columns.ownerName'),
      field: 'seller_Name',
      suppressMovable: true,
      sortable: true,
      width: 120,
      valueFormatter: emptyValueFormatter,
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('seller_Name'),
    },
    {
      headerName: t('unitMaster.columns.status'),
      field: 'status',
      suppressMovable: true,
      sortable: true,
      width: 120,
      valueFormatter: emptyValueFormatter,
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('status'),
    },
    {
      headerName: t('unitMaster.columns.bedrooms'),
      field: 'bedrooms',
      suppressMovable: true,
      sortable: true,
      width: 120,
      valueFormatter: emptyValueFormatter,
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('bedrooms'),
    },
    {
      headerName: t('unitMaster.columns.furnished'),
      suppressMovable: true,
      sortable: true,
      width: 120,
      valueGetter: (p) => accessors.facilities(p.data),
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('facilities', accessors.facilities),
    },
    {
      headerName: t('unitMaster.columns.community'),
      suppressMovable: true,
      sortable: true,
      width: 160,
      valueGetter: (p) => accessors.community(p.data),
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('community', accessors.community),
    },
    {
      headerName: t('unitMaster.columns.maidRoom'),
      suppressMovable: true,
      sortable: true,
      width: 110,
      valueGetter: (p) => accessors.maidRoom(p.data),
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('maidRoom', accessors.maidRoom),
    },
    {
      headerName: t('unitMaster.columns.totalArea'),
      field: 'total_Area',
      suppressMovable: true,
      sortable: true,
      width: 120,
      valueFormatter: emptyValueFormatter,
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('total_Area'),
    },
    {
      headerName: t('unitMaster.columns.floor'),
      field: 'floor',
      suppressMovable: true,
      sortable: true,
      width: 120,
      valueFormatter: emptyValueFormatter,
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('floor'),
    },
    {
      headerName: t('unitMaster.columns.unitView'),
      field: 'unit_View',
      suppressMovable: true,
      sortable: true,
      width: 120,
      valueFormatter: emptyValueFormatter,
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('unit_View'),
    },
    {
      headerName: t('unitMaster.columns.ratePerSqft'),
      field: 'sqft_Rate',
      suppressMovable: true,
      sortable: true,
      width: 120,
      valueFormatter: emptyValueFormatter,
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('sqft_Rate'),
    },
    {
      headerName: t('unitMaster.columns.unitPrice'),
      suppressMovable: true,
      sortable: true,
      width: 120,
      valueGetter: (p) => accessors.unitPrice(p.data),
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('unitPrice', accessors.unitPrice),
    },
    {
      headerName: t('unitMaster.columns.rentPerAnnum'),
      field: 'rent_Per_Annum',
      suppressMovable: true,
      sortable: true,
      width: 120,
      valueFormatter: emptyValueFormatter,
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('rent_Per_Annum'),
    },
    {
      headerName: t('unitMaster.columns.propertyNo'),
      field: 'property_No',
      suppressMovable: true,
      sortable: true,
      width: 120,
      valueFormatter: emptyValueFormatter,
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('property_No'),
    },
    {
      headerName: t('unitMaster.columns.multiPurpose'),
      field: 'usp',
      suppressMovable: true,
      sortable: true,
      width: 120,
      valueFormatter: emptyValueFormatter,
      headerComponent: ColumnFilterHeader,
      headerComponentParams: buildFilterParams('usp'),
    },
  ];

  const handlenew = () => {
    setFormModal({ mode: 'create', data: null });
  };
  const handleEdit = (rowsData) => {
    if (rowsData) {
      setFormModal({ mode: 'edit', data: rowsData });
    }
  };
  const handleView = (rowsData) => {
    if (rowsData) {
      setFormModal({ mode: 'view', data: rowsData });
    }
  };
  const handleDelete = (rowsData) => {
    if (rowsData) {
      setSelectedRow(rowsData);
      setPreviewModal(true);
    }
  };
  const closeFormModal = () => {
    setFormModal({ mode: null, data: null });
  };
  const handleFormSaved = () => {
    closeFormModal();
    getItems(1);
  };

  const handleClearFilters = () => {
    setFormData(initialFormData);
    setUnitNoOptions([]);
    setColumnFilters({});
  };

  const handleDropDownChange = async ({ name, value }) => {
    if (name === 'propertyNo') {
      setFormData((prev) => ({ ...prev, propertyNo: value, unitNo: null }));
      setUnitNoOptions([]);
      const propertyValue = getSelectValue(value);
      if (propertyValue) {
        try {
          const params = new URLSearchParams();
          params.append('DropdownFor', 'CustUnitNoByPropertyNo');
          params.append('CascadValue', propertyValue);
          const res = await apiService.getApiParamater('CUSTOMER_CASCAD', `?${params.toString()}`);
          setUnitNoOptions(res?.data?.items || []);
        } catch (e) {
          console.error('Error loading unit numbers:', e);
        }
      }
      return;
    }
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const exportPDF = () => {
    if (!exportData?.length) {
      alert("No data available to export");
      return;
    }

    const doc = new jsPDF("landscape");

    const primaryColor = [110, 81, 153]; // #6E5199

    // ===== Header =====
    doc.setFillColor(...primaryColor);
    doc.rect(0, 0, 297, 25, "F");

    doc.setTextColor(255, 255, 255);
    doc.setFont("helvetica", "bold");
    doc.setFontSize(20);
    doc.text("UNIT LIST REPORT", 148.5, 15, { align: "center" });

    doc.setFontSize(9);
    doc.text(
      `Generated On: ${new Date().toLocaleDateString()}`,
      280,
      21,
      { align: "right" }
    );

    // Reset text color
    doc.setTextColor(0, 0, 0);

    // ===== Columns =====
    const tableColumn = [
      "Property No",
      "Property Name",
      "Unit No",
      "Ref No",
      "Unit Type",
      "Unit Category",
      "Status",
      "Area",
      "Total Value",
      "Owner Name",
    ];

    // ===== Rows =====
    const tableRows = exportData.map((item) => [
      item.property_No || "-",
      item.property_Name || "-",
      item.unit_No || "-",
      item.ref_No || "-",
      item.unit_Type || "-",
      item.unit_Category || "-",
      item.status || "-",
      Number(item.total_Area || 0).toLocaleString(),
      Number(item.total_Value || 0).toLocaleString(),
      item.seller_Name || "-",
    ]);

    // ===== Table =====
    doc.autoTable({
      startY: 35,
      head: [tableColumn],
      body: tableRows,
      theme: "grid",

      styles: {
        fontSize: 8,
        cellPadding: 3,
        valign: "middle",
        lineColor: [220, 220, 220],
        lineWidth: 0.1,
      },

      headStyles: {
        fillColor: primaryColor,
        textColor: [255, 255, 255],
        fontStyle: "bold",
        halign: "center",
        fontSize: 9,
      },

      alternateRowStyles: {
        fillColor: [248, 246, 252],
      },

      bodyStyles: {
        textColor: [50, 50, 50],
      },

      margin: {
        left: 10,
        right: 10,
      },

      didDrawPage: function (data) {
        const pageCount = doc.internal.getNumberOfPages();

        doc.setFontSize(8);
        doc.setTextColor(120);

        doc.text(
          `Page ${doc.internal.getCurrentPageInfo().pageNumber} of ${pageCount}`,
          data.settings.margin.left,
          doc.internal.pageSize.height - 5
        );

        doc.text(
          "Unit List",
          doc.internal.pageSize.width - 40,
          doc.internal.pageSize.height - 5
        );
      },
    });

    doc.save(`Unit_List.pdf`);
  };
  return (
    <div className="p-3 unit-list-page">
      <div className="cost-center-section">
        <div className="d-flex mt-3 cursor-pointer slide-header" onClick={() => setFilterTab(!FilterTab)}>
          <div className="h6 pt-1">{t('common.searchParameters')}</div>
        </div>
        <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
          <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
            <div className="d-flex gap-3 align-items-stretch">
            <div className="form-group grid-contain flex-grow-1">
              <SearchSelect
                label={t('unitMaster.filters.property')}
                value={formData.propertyNo}
                options={searchDropdowns?.UMSearchPropertyNo}
                onChange={(selectedOption) => handleDropDownChange({ name: 'propertyNo', value: selectedOption })}
              />
              <SearchSelect
                label={t('unitMaster.filters.unitNo')}
                value={formData.unitNo}
                options={unitNoOptions}
                isDisabled={!formData.propertyNo}
                onChange={(selectedOption) => handleDropDownChange({ name: 'unitNo', value: selectedOption })}
              />
              <SearchSelect
                label={t('unitMaster.filters.unitView')}
                value={formData.unitView}
                options={searchDropdowns?.UMSearchUnitView}
                onChange={(selectedOption) => handleDropDownChange({ name: 'unitView', value: selectedOption })}
              />
              <SearchSelect
                label={t('unitMaster.filters.status')}
                value={formData.status}
                options={searchDropdowns?.UMSearchStatus}
                onChange={(selectedOption) => handleDropDownChange({ name: 'status', value: selectedOption })}
              />
              <SearchSelect
                label={t('unitMaster.filters.type')}
                value={formData.unitType}
                options={searchDropdowns?.UMSearchUnitType}
                onChange={(selectedOption) => handleDropDownChange({ name: 'unitType', value: selectedOption })}
              />
              <SearchSelect
                label={t('unitMaster.filters.bedroom')}
                value={formData.bedrooms}
                options={searchDropdowns?.UMSearchBedrooms}
                onChange={(selectedOption) => handleDropDownChange({ name: 'bedrooms', value: selectedOption })}
              />
              <SearchSelect
                label={t('unitMaster.filters.bathrooms')}
                value={formData.bathrooms}
                options={searchDropdowns?.UMSearchBathrooms}
                onChange={(selectedOption) => handleDropDownChange({ name: 'bathrooms', value: selectedOption })}
              />
              <SearchSelect
                label={t('unitMaster.filters.maidRoom')}
                value={formData.maidRoom}
                options={searchDropdowns?.UMSearchMaidRoom}
                onChange={(selectedOption) => handleDropDownChange({ name: 'maidRoom', value: selectedOption })}
              />
              <SearchSelect
                label={t('unitMaster.filters.community')}
                value={formData.communityName}
                options={searchDropdowns?.UMSearchCommunityName}
                onChange={(selectedOption) => handleDropDownChange({ name: 'communityName', value: selectedOption })}
              />
              <SearchSelect
                label={t('unitMaster.filters.leased')}
                value={formData.leased}
                options={searchDropdowns?.UMSearchLeased}
                onChange={(selectedOption) => handleDropDownChange({ name: 'leased', value: selectedOption })}
              />
              <SearchSelect
                label={t('unitMaster.filters.balcony')}
                value={formData.balcony}
                options={searchDropdowns?.UMSearchBalcony}
                onChange={(selectedOption) => handleDropDownChange({ name: 'balcony', value: selectedOption })}
              />
              <SearchSelect
                label={t('unitMaster.filters.storeRooms')}
                value={formData.storeRooms}
                options={searchDropdowns?.UMSearchStoreRooms}
                onChange={(selectedOption) => handleDropDownChange({ name: 'storeRooms', value: selectedOption })}
              />
              <SearchSelect
                label={t('unitMaster.filters.furnishing')}
                value={formData.furnishing}
                options={searchDropdowns?.UMSearchFurnishing}
                onChange={(selectedOption) => handleDropDownChange({ name: 'furnishing', value: selectedOption })}
              />
              <div className="unit-search-last-rows">
                <SearchVerticalRange
                  minLabel={t('unitMaster.filters.budgetMin')}
                  maxLabel={t('unitMaster.filters.budgetMax')}
                  minName="budgetMin"
                  maxName="budgetMax"
                  minValue={formData.budgetMin}
                  maxValue={formData.budgetMax}
                  onChange={handleInputChange}
                />
                <SearchVerticalRange
                  minLabel={t('unitMaster.filters.sizeMin')}
                  maxLabel={t('unitMaster.filters.sizeMax')}
                  minName="sizeMin"
                  maxName="sizeMax"
                  minValue={formData.sizeMin}
                  maxValue={formData.sizeMax}
                  onChange={handleInputChange}
                />
                <SearchVerticalRange
                  minLabel={t('unitMaster.filters.psfMin')}
                  maxLabel={t('unitMaster.filters.psfMax')}
                  minName="psfMin"
                  maxName="psfMax"
                  minValue={formData.psfMin}
                  maxValue={formData.psfMax}
                  onChange={handleInputChange}
                />
              </div>
            </div>
            <div className="unit-search-actions">
              <div onClick={() => getItems()} className="mainbtn flex-end gap-2">
                <FaFileCircleExclamation color="#fff" className="center mt-2 mx-2" />
                <div className="center">{t('common.search')}</div>
              </div>
              <div onClick={() => handleClearFilters()} className="mainbtnRed flex-end gap-2">
                <RiRefreshLine color="#fff" className="center mt-2 mx-2" />
                <div className="center">{t('common.reset')}</div>
              </div>
              {(role === 'Admin' || role === 'admin') && (
                <div onClick={() => exportPDF()} className="mainbtnGry flex-end gap-2">
                  <FaFileExport color="#fff" className="center mt-2 mx-2" />
                  <div className="center">{t('common.export')}</div>
                </div>
              )}
            </div>
            </div>
          </div>
        </div>
      </div>
      <div className="border-box2 p-3">
        {loading ? (
          <div>{t('common.loading')}</div>
        ) : (
          <>
            <div className="d-flex justify-contant-between ">
              <h5 className="col mainInvHead">{t('unitMaster.pageTitle')}</h5>
              <div className="d-flex justify-content-end gap-1">
                <div className="col center">
                  <button className="mainbtn " type="submit" onClick={() => handlenew()}>
                    <IoAddSharp color="#fff" className="center mt-1" /> <div>{t('common.add')}</div>
                  </button>
                </div>
              </div>
            </div>
            <div className="gridshad  mt-2">
              <div className="ag-theme-quartz unit-grid" style={{ height: 650 }}>
                <AgGridReact
                  getRowStyle={(params) => {
                    if (params.node.rowIndex % 2 === 0) {
                      return { background: '#F0EDF5' };
                    } else {
                      return { background: '#fff' };
                    }
                  }}
                  rowData={filteredRowData}
                  enableFilter={true}
                  floatingFilter={true}
                  columnDefs={columnDefs}
                  frameworkComponents={{ BtnCellRenderer }}
                />
              </div>
              <Pagination pageSize={pageSize} setPageSize={setPageSize} pagination={pagination} getItems={getItems} />
            </div>
          </>
        )}
      </div>

      <Modal show={previewModal} size="md" onHide={() => setPreviewModal(false)} backdrop="static" keyboard={false}>
        <Modal.Header closeButton>
          <Modal.Title>{t('unitMaster.deleteTitle')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Modal.Title>{t('unitMaster.deleteConfirm', { name: selectedRow?.unit_No })}</Modal.Title>
        </Modal.Body>
        <Modal.Footer className="end p-3">
          <button className="mainbtnRed" onClick={() => setPreviewModal(false)}>
            {t('common.cancel')}
          </button>
          <button className="mainbtn">{t('common.delete')}</button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={!!formModal.mode}
        onHide={closeFormModal}
        backdrop="static"
        keyboard={false}
        centered
        dialogClassName="unit-form-modal"
        contentClassName="p-0"
      >
        <Modal.Body style={{ padding: 0 }}>
          {formModal.mode === 'create' && <CreateUnitMaster onClose={closeFormModal} onSaved={handleFormSaved} />}
          {(formModal.mode === 'edit' || formModal.mode === 'view') && (
            <UpdateUnitMaster
              initialData={formModal.data}
              viewOnly={formModal.mode === 'view'}
              onClose={closeFormModal}
              onSaved={handleFormSaved}
            />
          )}
        </Modal.Body>
      </Modal>
    </div>
  );
};
export default UnitListing;
class BtnCellRenderer extends Component {
  render() {
    const { data, onView, onEdit, onDelete, canDelete } = this.props;
    const stop = (fn) => (e) => {
      e.stopPropagation();
      fn?.(data);
    };
    return (
      <div className="unit-row-actions">
        <FaRegEye color="#6E5199" size={16} title={i18n.t('common.view')} onClick={stop(onView)} />
        <HiPencil color="#313a46" size={16} title={i18n.t('common.edit')} onClick={stop(onEdit)} />
        <FaTrash
          color={canDelete ? '#DC3545' : '#c9c9c9'}
          size={14}
          title={canDelete ? i18n.t('common.delete') : i18n.t('common.onlyAdminCanDelete')}
          style={{ cursor: canDelete ? 'pointer' : 'not-allowed' }}
          onClick={canDelete ? stop(onDelete) : undefined}
        />
      </div>
    );
  }
}
